import { createFeature, createReducer, on } from '@ngrx/store';
import { MipsFileRepositoryActions } from '@store/actions/mips-file-repository/mips-file-repository.actions';
import { MipsFileRepositoryItem } from '@models/mips-file-repository.model';

export const mipsFileRepositoryFeatureKey = 'mips-file-repository';

export interface State {
  files: MipsFileRepositoryItem[];
  loading: boolean;
  downloading: boolean;
  viewing: boolean;
  error: string | null;
}

export const initialState: State = {
  files: [],
  loading: false,
  downloading: false,
  viewing: false,
  error: null,
};

export const reducer = createReducer(
  initialState,

  on(MipsFileRepositoryActions.getFiles, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(MipsFileRepositoryActions.getFilesSuccess, (state, { files }) => ({
    ...state,
    files,
    loading: false,
    error: null,
  })),
  on(MipsFileRepositoryActions.getFilesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(MipsFileRepositoryActions.downloadDocument, (state) => ({
    ...state,
    downloading: true,
    error: null,
  })),
  on(MipsFileRepositoryActions.downloadDocumentSuccess, (state) => ({
    ...state,
    downloading: false,
    error: null,
  })),
  on(MipsFileRepositoryActions.downloadDocumentFailure, (state, { error }) => ({
    ...state,
    downloading: false,
    error,
  })),

  on(MipsFileRepositoryActions.viewDocument, (state) => ({
    ...state,
    viewing: true,
    error: null,
  })),
  on(MipsFileRepositoryActions.viewDocumentSuccess, (state) => ({
    ...state,
    viewing: false,
    error: null,
  })),
  on(MipsFileRepositoryActions.viewDocumentFailure, (state, { error }) => ({
    ...state,
    viewing: false,
    error,
  })),
);

export const mipsFileRepositoryFeature = createFeature({
  name: mipsFileRepositoryFeatureKey,
  reducer,
});
